import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(
  'ec3122d88b8492372ea8f004188b713dTz01NDY2MixFPTE3MDA0MjA5NDM5NDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI='
);

export default function MuiXLicense() {
  return null;
}
